import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import type { AxiosInstance } from "axios";

let productionGrainsApiPromise: Promise<AxiosInstance> | null = null;

const getProductionGrainsApi = async (): Promise<AxiosInstance | null> => {
  if (productionGrainsApiPromise !== null) return productionGrainsApiPromise;
  productionGrainsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return productionGrainsApiPromise;
};

export interface GetProductionGrainsListProps {
  Nombre?: string;
  AplicaPPMB?: boolean;
  SumaHA?: boolean;
  GranosAdmis?: number[];
  "P.Pagina": number;
  "P.Records"?: number;
}

export interface CreateProductionGrainBody {
  nombre: string;
  aplicaPPMB: boolean;
  granoAdmis: number;
  sumaHA: boolean;
}

export interface UpdateProductionGrainBody extends CreateProductionGrainBody {
  id: number;
}

export const getProductionGrainsList = async (
  props: GetProductionGrainsListProps,
) => {
  const api = await getProductionGrainsApi();
  if (!api) return;

  const response = await api.get(
    `/GranosProductivos/all?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getProductionGrain = async (id: number) => {
  const api = await getProductionGrainsApi();
  if (!api) return;

  const response = await api.get(`/GranosProductivos/${id}`);

  return response.data;
};

export const updateProductionGrain = async (
  body: UpdateProductionGrainBody,
) => {
  const api = await getProductionGrainsApi();
  if (!api) return;

  const response = await api.put(`/GranosProductivos/${body.id}`, body);

  return response.data;
};

export const createProductionGrain = async (
  body: CreateProductionGrainBody,
) => {
  const api = await getProductionGrainsApi();
  if (!api) return;

  const response = await api.post(`/GranosProductivos`, body);

  return response.data;
};
